import * as React from 'react'
import { useTranslation } from 'react-i18next'
import Divider from 'components/Divider'
import { FormApi } from 'final-form'
import * as Yup from 'yup'
import { Form } from 'components/FormManager'
import { YesNoRadio } from 'components/Input'
import { StepNavigation } from 'components/Step'
import FormHeading from './FormHeading'
import InsuranceFields from './InsuranceFields'
import { useReduxCallStoreActions } from 'hooks/events'
import { useSelector } from 'react-redux'
import { selectFormsState } from 'redux/appStore'

declare module 'types/form' {
  export interface Forms {
    ThirdPartyInsurance: FormApi
  }
}

export const ThirdPartyInsurance = () => {
  const { t } = useTranslation()
  const { update } = useReduxCallStoreActions()
  const { ldr } = useSelector(selectFormsState) as any
  const { thirdPartyInsurance, ...restValues } = ldr

  return (
    <Form
      name="ThirdPartyInsurance"
      schema={thirdPartyInsuranceSchema}
      initialValues={thirdPartyInsurance}
      autoSaveDebounce={200}
      autoSaveSync={(thirdPartyInsurance) => {
        update({
          ldr: {
            ...restValues,
            thirdPartyInsurance,
          },
        })
      }}
    >
      <YesNoRadio name="thirdPartyInsurance" label={t('ldr.thirdPartyInsurance.heading')}>
        <Divider />
        <FormHeading>{t('ldr.thirdPartyInsurance.info')}</FormHeading>
        <InsuranceFields />
      </YesNoRadio>
      <StepNavigation />
    </Form>
  )
}

export default ThirdPartyInsurance

const thirdPartyInsuranceSchema = Yup.object().shape({
  thirdPartyInsurance: Yup.string().required('Required'),
})
